var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-speed',
        type: 'meter',
        value: _vm.telemetry2.truck.speed,
        min: _vm.$convertToUnit(2.77778, 'unit_speed'),
        max: _vm.$convertToUnit(36.1111, 'unit_speed'),
        minAngle: -118,
        maxAngle: 118
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-engineRpm',
        type: 'meter',
        value: _vm.telemetry2.truck.rpm,
        min: 300,
        max: 2700,
        minAngle: -118,
        maxAngle: 118
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-fuel',
        type: 'meter',
        value: _vm.telemetry2.truck.fuelLevel,
        min: 0,
        max: _vm.telemetry2.truck.fuelCapacity,
        minAngle: -53,
        maxAngle: 53
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-waterTemperature',
        type: 'meter',
        value: _vm.telemetry2.truck.engineWaterTemperature,
        min: _vm.$convertToUnit(40, 'unit_degrees'),
        max: _vm.$convertToUnit(100, 'unit_degrees'),
        minAngle: -55,
        maxAngle: 55
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-oilPressure',
        type: 'meter',
        value: _vm.telemetry2.truck.oilPressure,
        min: 0,
        max: _vm.$convertToUnit(116, 'unit_pressure'),
        minAngle: -53,
        maxAngle: 53
      },false)),_c('Cadran',_vm._b({},'Cadran',{
        classCSS: 'truck-fuelAverageConsumption',
        type: 'meter',
        value: _vm.telemetry2.truck.fuelAverageConsumption,
        min: 0,
        max: _vm.$convertToUnit(120, 'unit_consumption'),
        minAngle: -56,
        maxAngle: 57
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }